import { Box, Button, CardMedia } from "@mui/material";
import { Helmet } from "react-helmet";
import ErrorImg from "images/401-Error.png";
import { useNavigate } from "react-router-dom";

const NotFoundPage = () => {
  const navigate = useNavigate();

  return (
    <>
      <Helmet>
        <title>Not Found</title>
      </Helmet>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          overflow: "auto",
          width: "100%",
        }}
      >
        <Box>
          <CardMedia
            sx={{ height: "calc(70vh)", objectFit: "contain" }}
            component="img"
            image={ErrorImg}
            alt="404 Error"
          />
        </Box>
        <Box sx={{ fontWeight: 800, fontSize: "20px", marginBottom: 2 }}>
          This Page Was Not Found
        </Box>
        <Button variant="contained" onClick={() => navigate("/home")}>
          Go To Home Page
        </Button>
      </Box>
    </>
  );
};

export default NotFoundPage;
